
import { PRICE_MARKUP_CHANGE_TYPE_API } from "../../../constants/api";
import axiosHttp from "../../interceptors/axios-interceptor";

export default function GetPriceMarkupChangeTypes(){
    const api = `${PRICE_MARKUP_CHANGE_TYPE_API}`;
    return axiosHttp.get(api);
}